function getDICOMwebUrl({ baseMap, location: l, dataset: d, store: s }) {
  const params =
    window.location.search && new URLSearchParams(window.location.search);
  const location = (params && params.get('region')) || l;
  const dataset = (params && params.get('dataset')) || d;
  const store = (params && params.get('store')) || s;
  const dicomwebBase = baseMap[location] || baseMap['default'];
  return `${dicomwebBase}/locations/${location}/datasets/${dataset}/dicomStores/${store}/dicomWeb`;
}

function getPrefetcher({
  enabled: e,
  displaySetCount: c,
  maxNumPrefetchRequests: r,
}) {
  const params =
    window.location.search && new URLSearchParams(window.location.search);
  let enabled = params && params.get('prefetch');
  switch (enabled) {
    case 'false':
      enabled = false;
      break;
    default:
      enabled = e;
  }
  let displaySetCount = params && params.get('prefetchCount');
  if (displaySetCount) {
    displaySetCount = Number(displaySetCount) || c;
  } else {
    displaySetCount = c;
  }
  let maxNumPrefetchRequests = params && params.get('prefetchRequests');
  if (maxNumPrefetchRequests) {
    maxNumPrefetchRequests = Number(maxNumPrefetchRequests) || r;
  } else {
    maxNumPrefetchRequests = r;
  }
  return {
    enabled: enabled,
    order: 'closest',
    displaySetCount: displaySetCount,
    preventCache: false,
    prefetchDisplaySetsTimeout: 300,
    maxNumPrefetchRequests: maxNumPrefetchRequests,
    displayProgress: true,
    includeActiveDisplaySet: true,
  };
}

export { getDICOMwebUrl, getPrefetcher };
